import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCategories } from 'reduxStore/categories/selectors';
import { selectDevices } from 'reduxStore/devices/selectors';
import DeviceDrawer from 'zComponents/molecules/DeviceDrawer';
import { Button, Col, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

function RenderDevicesPanelContent({ searchResults = [], isSearching = false }) {
	const {
		token: {
			colorTextLabel,
			fontWeightStrong,
			padding,
			borderRadius,
			paddingSM,
			colorFill,
			colorPrimaryText,
			lineHeight,
			lineHeightLG,
			fontSizeLG
		}
	} = theme.useToken();

	const allDevicesData = useSelector(selectDevices);
	const allCategoriesData = useSelector(selectCategories);
	const [openDrawer, setOpenDrawer] = useState(false);
	const [selectedDevice, setSelectedDevice] = useState(null);
	const displayData = isSearching ? searchResults.map((result) => result.item) : allDevicesData;

	if (displayData.length === 0) {
		return (
			<Flex align='center' justify='center' vertical style={{ width: '100%', padding }}>
				<Empty description={isSearching ? 'No search results found' : 'No devices to display'} />
			</Flex>
		);
	}

	return (
		<Row gutter={[20, 20]} justify='start'>
			{displayData.map((device, index) => (
				<Col key={isSearching ? `search-${index}` : index} xl={8} lg={12} sm={24}>
					<Flex
						vertical
						style={{
							border: `1px solid ${colorFill}`,
							padding: paddingSM,
							borderRadius,
							boxSizing: 'border-box'
						}}
					>
						<Flex align='center' justify='space-between'>
							<Flex vertical flex={1} style={{ width: 0 }}>
								<Text
									ellipsis={{ tooltip: device?.name }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: fontWeightStrong,
										fontSize: fontSizeLG,
										lineHeight: lineHeightLG
									}}
								>
									{device?.name || '--'}
								</Text>
								<Text
									ellipsis={{
										tooltip: `Category: ${allCategoriesData?.find((cat) => cat?.categoryID === device?.categoryID)?.name || '-'}`
									}}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: 500,
										lineHeight: lineHeight
									}}
								>
									Category:{' '}
									{allCategoriesData?.find((cat) => cat?.categoryID === device?.categoryID)?.name ||
										'--'}
								</Text>
							</Flex>
							<Button
								onClick={() => {
									setSelectedDevice(device?.deviceID);
									setOpenDrawer(true);
								}}
								type='text'
								style={{ color: colorPrimaryText }}
							>
								View Device
							</Button>
						</Flex>
					</Flex>
				</Col>
			))}
			<DeviceDrawer deviceID={selectedDevice} visible={openDrawer} setVisible={setOpenDrawer} />
		</Row>
	);
}

export default RenderDevicesPanelContent;
